import React from 'react';
import { WebImpersonationSession } from '../services/webImpersonation';

interface Props {
  session: WebImpersonationSession;
  onExit: () => void;
  isExiting?: boolean;
  error?: string;
}

const FounderImpersonationBanner: React.FC<Props> = ({ session, onExit, isExiting = false, error = '' }) => {
  const targetLabel = session.targetUser.displayName || session.targetUser.phoneNumber || session.targetUser.email || session.targetUser.uid;
  const founderLabel = session.founderUser.displayName || session.founderUser.phoneNumber || session.founderUser.email || session.founderUser.uid;

  return (
    <div className="sticky top-0 z-[70] border-b border-amber-200 bg-amber-50/95 backdrop-blur">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-2 px-4 py-2 text-[12px] text-amber-950 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 items-center gap-2">
            <span className="rounded-full bg-amber-500 px-2 py-1 text-[10px] font-black uppercase tracking-[0.22em] text-white">
              Founder
            </span>
            <p className="min-w-0 truncate font-semibold">
              Founder impersonation mode. You are viewing as {targetLabel}.
            </p>
            <span className="hidden rounded-full border border-amber-300 bg-white/70 px-2 py-1 text-[10px] font-semibold text-amber-800 sm:inline-flex">
              Founder: {founderLabel}
            </span>
          </div>

          <button
            type="button"
            onClick={onExit}
            disabled={isExiting}
            className="inline-flex shrink-0 items-center justify-center rounded-full border border-amber-300 bg-white px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-amber-900 transition hover:border-amber-400 hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isExiting ? 'Exiting…' : 'Exit'}
          </button>
        </div>

        {error ? (
          <p className="text-[11px] font-medium text-rose-700">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default FounderImpersonationBanner;
